import styled, { keyframes } from "styled-components";

// Estilos da célula editável de status do vínculo (aba Projetos da seletiva).

export const Cell = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Select = styled.select`
  min-width: 160px;
  padding: 8px 10px;
  border-radius: 6px;
  border: 1px solid ${({ theme }) => theme.colors.neutral.gray3};
  background: ${({ theme }) => theme.colors.neutral.white};
  color: ${({ theme }) => theme.colors.neutral.black};
  cursor: pointer;
  ${({ theme }) => theme.font.body.sm}

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.primary.vividCerulean};
  }

  &:disabled {
    opacity: 0.6;
    cursor: wait;
  }
`;

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

export const Spinner = styled.span`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  border-radius: 50%;
  border: 2px solid ${({ theme }) => theme.colors.neutral.gray3};
  border-top-color: ${({ theme }) => theme.colors.primary.vividCerulean};
  animation: ${spin} 0.7s linear infinite;
`;
